module.exports = __webpack_public_path__ + "media/src/assets/images/logo-odakyu_pro-fada79bf8f44c768cbdc5159833070bd.png";